import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w50 pd-rt-7 chart-box" }
const _hoisted_2 = { class: "time-tracking-report-chart" }
const _hoisted_3 = { class: "chart-top" }
const _hoisted_4 = { class: "chart-top-lt" }
const _hoisted_5 = { class: "chart-top-rt" }
const _hoisted_6 = { class: "chart-select pd-rt-7" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "chart-btm" }
const _hoisted_9 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_10 = {
  key: 1,
  class: "chart-container"
}
const _hoisted_11 = {
  ref: "chartCanvas",
  width: "600",
  height: "400"
}
const _hoisted_12 = {
  key: 2,
  class: "chart-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.constants.TIME_TRACKING_REPORT_TEXT), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("select", {
              class: "v1-selectbox",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedProject) = $event)),
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fetchSprintData && _ctx.fetchSprintData(...args)))
            }, [
              _cache[3] || (_cache[3] = _createElementVNode("option", { value: "" }, "Select Project", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: project.key,
                  value: project.key
                }, _toDisplayString(project.name), 9, _hoisted_7))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.selectedProject]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("div", { class: "loading-spinner" }, "Loading sprint data...", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("canvas", _hoisted_11, null, 512)
            ])),
        (_ctx.chartError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("p", null, _toDisplayString(_ctx.chartError), 1),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.retryChart && _ctx.retryChart(...args))),
                class: "retry-chart-btn"
              }, "Retry Chart")
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}